import { addEventListener } from './utils';
import { getLinkClickEventProperties } from '@squareup/public-web-browser-helpers/cdp-formatter';

const footerLinkTrackingHelper = {
  footerNavigationLinkHandler: (event: Event) => {
    const target = event.target;
    let properties;
    const linkProperties = getLinkClickEventProperties(event);
    if (linkProperties) {
      properties = linkProperties.cdpProperties;
    }
    if (target instanceof Element) {
      window.Sq.Tracking.track(
        {
          action: 'Click Footer Navigation Link',
          properties,
        },
        { destinations: ['cdp'] }
      );
    }
  },
  openLocaleSelectorModalHandler: (event: Event) => {
    const target = event.target as HTMLElement;
    const properties: Record<string, string> = {
      parentElementId: 'footer',
      triggerText: target.innerText.trim(),
    };
    if (target instanceof Element) {
      window.Sq.Tracking.track(
        {
          action: 'Open Locale Selector Modal',
          properties,
        },
        { destinations: ['cdp'] }
      );
    }
  },
  attachEventListeners: () => {
    const footerElement: HTMLElement = document.getElementById('footer') as HTMLElement;
    const localeSelectorTrigger: HTMLElement = document.getElementById('locale-selector-trigger') as HTMLElement;

    addEventListener(footerElement, 'click', footerLinkTrackingHelper.footerNavigationLinkHandler, 'a[href]');
    addEventListener(localeSelectorTrigger, 'click', footerLinkTrackingHelper.openLocaleSelectorModalHandler);
  },
  initialize: (): Promise<void> =>
    new Promise((resolve) => {
      footerLinkTrackingHelper.attachEventListeners();
      resolve();
    }),
};

export default footerLinkTrackingHelper;
